import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";

const Hero = () => {
  const { t } = useTranslation();

  const particlesInit = useCallback(async engine => {
    // Inicializa o motor de partículas
    await loadSlim(engine);
  }, []);

  const particleOptions = {
    background: {
      color: {
        value: '#0D0D2B', // Cor de fundo do seu site
      },
    },
    fpsLimit: 120,
    interactivity: {
      events: {
        onHover: {
          enable: true,
          mode: "repulse", // Partículas se afastam do mouse
        },
        resize: true,
      },
      modes: {
        repulse: {
          distance: 100,
          duration: 0.4,
        },
      },
    },
    particles: {
      color: {
        value: "#00BFFF", // Cor das partículas (Accent color)
      },
      links: {
        color: "#2A2A4A", // Cor das linhas que ligam as partículas (Secondary color)
        distance: 150,
        enable: true,
        opacity: 0.5,
        width: 1,
      },
      move: {
        direction: "none",
        enable: true,
        outModes: {
          default: "bounce",
        },
        random: false,
        speed: 1,
        straight: false,
      },
      number: {
        density: {
          enable: true,
          area: 800,
        },
        value: 80,
      },
      opacity: {
        value: 0.5,
      },
      shape: {
        type: "circle",
      },
      size: {
        value: { min: 1, max: 3 },
      },
    },
    detectRetina: true,
  }

  return (
    <section id="hero" className="min-h-screen flex items-center justify-center relative">
      {/* O componente de partículas fica no fundo */}
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={particleOptions}
        className="absolute top-0 left-0 w-full h-full z-0"
      />
      
      {/* O conteúdo de texto fica na frente */}
      <div className="container mx-auto px-6 text-center relative z-10">
        <h1 
          className="text-4xl md:text-6xl font-bold text-white mb-4"
          data-aos="fade-up"
        >
          {t('hero_title')}
        </h1>
        <p 
          className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl mx-auto"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {t('hero_subtitle')}
        </p>
        <div data-aos="fade-up" data-aos-delay="400">
            <a href="#contact" className="bg-accent hover:bg-white hover:text-accent text-primary font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-110">
                {t('hero_button')}
            </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;